import React, { useMemo } from 'react';
import type File from '../../../interfaces/File';

import { Avatar } from 'antd';
import { useAuth } from '../../../hooks/useAuth';
import { getAvatarColor } from '../../../utils/avatarColors';
import TruncatedTooltip from '../../Common/TruncatedTooltip';
import { useTranslation } from 'react-i18next';

interface FilesTableSharedByCellProps {
  file: File;
}

const FilesTableSharedByCell: React.FC<FilesTableSharedByCellProps> = ({ file }) => {
  const { authenticatedUser } = useAuth();
  const { t } = useTranslation();

  /**
   * Check if the file is owned by the authenticated user
   */
  const isFileMine = useMemo(() => {
    return file.ownerId === authenticatedUser?.id;
  }, [file, authenticatedUser]);

  // Generate a consistent ID from the sharedBy string for color consistency
  const sharedById = useMemo(() => {
    if (!file?.sharedBy) return 0;
    // Simple hash function to convert string to number
    let hash = 0;
    for (let i = 0; i < file.sharedBy.length; i++) {
      const char = file.sharedBy.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash);
  }, [file?.sharedBy]);

  const displayText = isFileMine ? t('common.me') : (file?.sharedBy ?? '');

  return (
    <div className="flex w-full min-w-0 flex-row items-center gap-2">
      <Avatar
        className="text-blue-dark! shrink-0!"
        style={{ backgroundColor: getAvatarColor(sharedById) }}
      >
        {file?.sharedBy?.[0]?.toUpperCase()}
      </Avatar>
      <span className="min-w-0 flex-1 overflow-hidden">
        <span className="block w-full min-w-0 overflow-hidden">
          <TruncatedTooltip className="block w-full min-w-0">{displayText}</TruncatedTooltip>
        </span>
      </span>
    </div>
  );
};

export default FilesTableSharedByCell;
